import styled from 'styled-components';

export const C = styled.div`
    font-size: 20px;
	font-weight: 600;
	color: #afafaf;
	margin-left: 32px;
`;